import React, { useEffect, useState } from 'react';
import { getAuthSession } from '../services/api';

function CheckoutPage() {
  const [cartItems, setCartItems] = useState([]);
  const [totals, setTotals] = useState({ subtotal: 0, tax: 0, total: 0 });
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('razorpay');

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: ''
  });

  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);

    loadCheckoutData();

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script && document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const loadCheckoutData = () => {
    try {
      const checkoutItems = JSON.parse(localStorage.getItem('checkoutItems') || '[]');
      const checkoutTotal = JSON.parse(localStorage.getItem('checkoutTotal') || '{}');
      setCartItems(checkoutItems);
      setTotals(checkoutTotal);
      setLoading(false);
    } catch (error) {
      console.error('Error loading checkout data:', error);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRazorpayPayment = async (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.email || !formData.phone) {
      alert('Please fill in all required fields');
      return;
    }
    setProcessing(true);
    try {
      const token = getAuthSession()?.token || localStorage.getItem('authToken') || '';
      const orderResponse = await fetch('/api/payments/razorpay/order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ amount: totals.total * 100, currency: 'INR', items: cartItems, customerEmail: formData.email, customerPhone: formData.phone, customerName: `${formData.firstName} ${formData.lastName}`, customerAddress: formData.address })
      });
      if (!orderResponse.ok) throw new Error('Failed to create order');
      const orderData = await orderResponse.json();
      const orderId = orderData.orderId || orderData.id;
      if (!window.Razorpay) { alert('Razorpay not loaded'); setProcessing(false); return; }
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY || 'YOUR_RAZORPAY_KEY',
        amount: totals.total * 100,
        currency: 'INR',
        order_id: orderId,
        name: 'Mental Health Platform',
        description: `Purchase of ${cartItems.length} product(s)`,
        handler: async (response) => {
          try {
            const verifyResponse = await fetch('/api/payments/razorpay/verify', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
              body: JSON.stringify({ razorpay_order_id: response.razorpay_order_id, razorpay_payment_id: response.razorpay_payment_id, razorpay_signature: response.razorpay_signature })
            });
            if (verifyResponse.ok) {
              localStorage.removeItem('cart');
              localStorage.removeItem('checkoutItems');
              localStorage.removeItem('checkoutTotal');
              alert('Payment successful!');
              window.location.href = '/';
            } else {
              alert('Payment verification failed.');
            }
          } catch (e) {
            alert('Payment error');
          } finally {
            setProcessing(false);
          }
        },
        prefill: { name: `${formData.firstName} ${formData.lastName}`, email: formData.email, contact: formData.phone },
        theme: { color: '#667eea' },
        modal: { ondismiss: () => setProcessing(false) }
      };
      new window.Razorpay(options).open();
    } catch (error) {
      alert('Payment error: ' + error.message);
      setProcessing(false);
    }
  };

  const handleCODSubmit = (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.email || !formData.phone) { alert('Required fields'); return; }
    alert('Order placed!');
    localStorage.removeItem('cart');
    localStorage.removeItem('checkoutItems');
    localStorage.removeItem('checkoutTotal');
    window.location.href = '/';
  };

  if (loading) return <><section className="page-header"><div className="container"><p>Loading...</p></div></section></>;
  if (cartItems.length === 0) return <><section className="page-header"><div className="container"><h2>Cart empty</h2><a href="/products">Continue Shopping</a></div></section></>;

  return (
    <>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-5-3.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Checkout</h2>
            <ul className="thm-breadcrumb"><li><a href="/">Home</a></li><li><span>/</span></li><li><span>Checkout</span></li></ul>
          </div>
        </div>
      </section>

      <section className="checkout-section" style={{ padding: '80px 0', backgroundColor: '#f9f9f9' }}>
        <div className="container">
          <div className="row" style={{ gap: '20px' }}>
            <div className="col-lg-8">
              <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
                <form onSubmit={paymentMethod === 'razorpay' ? handleRazorpayPayment : handleCODSubmit}>
                  <h3 style={{ marginBottom: '25px' }}>Billing Information</h3>
                  <div className="row" style={{ marginBottom: '20px' }}>
                    <div className="col-md-6">
                      <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '15px' }} />
                    </div>
                    <div className="col-md-6">
                      <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '15px' }} />
                    </div>
                  </div>
                  <div className="row" style={{ marginBottom: '20px' }}>
                    <div className="col-md-6">
                      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '15px' }} />
                    </div>
                    <div className="col-md-6">
                      <input type="tel" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '15px' }} />
                    </div>
                  </div>
                  <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '15px' }} />
                  <div className="row" style={{ marginBottom: '20px' }}>
                    <div className="col-md-6"><input type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} /></div>
                    <div className="col-md-6"><input type="text" name="state" placeholder="State" value={formData.state} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} /></div>
                  </div>
                  <input type="text" name="zipCode" placeholder="ZIP" value={formData.zipCode} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '30px' }} />

                  <h3 style={{ marginBottom: '20px', marginTop: '30px', paddingTop: '30px', borderTop: '2px solid #eee' }}>Payment</h3>
                  <label style={{ display: 'block', padding: '15px', border: `2px solid ${paymentMethod === 'razorpay' ? '#007bff' : '#ddd'}`, borderRadius: '5px', marginBottom: '10px', backgroundColor: paymentMethod === 'razorpay' ? '#f0f8ff' : '#fff', cursor: 'pointer' }}>
                    <input type="radio" value="razorpay" checked={paymentMethod === 'razorpay'} onChange={(e) => setPaymentMethod(e.target.value)} />
                    <strong style={{ marginLeft: '10px' }}>Online Payment (Razorpay)</strong>
                  </label>
                  <label style={{ display: 'block', padding: '15px', border: `2px solid ${paymentMethod === 'cod' ? '#007bff' : '#ddd'}`, borderRadius: '5px', backgroundColor: paymentMethod === 'cod' ? '#f0f8ff' : '#fff', cursor: 'pointer' }}>
                    <input type="radio" value="cod" checked={paymentMethod === 'cod'} onChange={(e) => setPaymentMethod(e.target.value)} />
                    <strong style={{ marginLeft: '10px' }}>Cash on Delivery</strong>
                  </label>

                  <button type="submit" disabled={processing} style={{ width: '100%', padding: '15px', backgroundColor: processing ? '#ccc' : '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', fontWeight: '600', marginTop: '20px' }}>
                    {processing ? '🔄 Processing...' : '✓ Complete Order'}
                  </button>
                </form>
              </div>
            </div>

            <div className="col-lg-4">
              <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', position: 'sticky', top: '20px' }}>
                <h3 style={{ marginBottom: '20px' }}>Order Summary</h3>
                <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '20px', paddingBottom: '20px', borderBottom: '2px solid #eee' }}>
                  {cartItems.map((item) => <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', fontSize: '14px' }}><div><p style={{ margin: 0, fontWeight: '600' }}>{item.name}</p><p style={{ margin: 0, fontSize: '12px', color: '#999' }}>Qty: {item.quantity}</p></div><p style={{ margin: 0, fontWeight: '600' }}>${(item.price * item.quantity).toFixed(2)}</p></div>)}
                </div>
                <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #eee' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', fontSize: '14px' }}><span>Subtotal:</span><span>${totals.subtotal?.toFixed(2) || '0.00'}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}><span>Tax:</span><span>${totals.tax?.toFixed(2) || '0.00'}</span></div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: '700' }}><span>Total:</span><span style={{ color: '#007bff' }}>₹{totals.total?.toFixed(2) || '0.00'}</span></div>
                <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f0f8ff', borderRadius: '5px', fontSize: '12px' }}><p style={{ margin: 0, marginBottom: '10px' }}><strong>✓ Secure Checkout</strong></p><p style={{ margin: 0 }}>Your info is encrypted and secure.</p></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CheckoutPage;
